import { Box, Grid } from '@mui/material';
import { useMedicalHealthInformationContext } from '../Context';
import Card from './Card';
import DialogViewer from './DialogViewer';
import { useState } from 'react';
import { DocumentReference } from '../types/MedicalHealthInformation';
import ErrorDialog from '@/features/misc/ErrorDialog';

// カードの横幅
const listCardWidth = 353;

const MedicalHealthInformationBranchDocumentReference = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [errorDialogMessage, setErrorDialogMessage] = useState('');
  const {
    activeMedicalHealthInformation,
    setDetailDocumentReference,
    detailDocumentReference,
    fetchMedicalHealthInformationDetail1ForDocumentReference
  } = useMedicalHealthInformationContext();

  const handleCardClick = (data: DocumentReference) => {
    setDetailDocumentReference(data);
    setIsOpenModal(true);
  };

  // 鮮明にする(マスク解除)
  const handleUnmask = async () => {
    try {
      await fetchMedicalHealthInformationDetail1ForDocumentReference(
        `DocumentReference/${detailDocumentReference.id}`,
        activeMedicalHealthInformation.facility_id.toString()
      );
    } catch (e) {
      if (e instanceof Error) {
        setErrorDialogMessage(e.message);
      }
      return Promise.reject(e);
    }
  };

  return (
    <Box sx={{ marginTop: '16px' }}>
      <Grid container direction={'row'} spacing={2}>
        <Grid item xs={0} md={3} sm={2} />
        <Grid item xs={12} md={6} sm={8}>
          <Grid container spacing={2} sx={{ paddingX: '20px', maxWidth: `calc(${listCardWidth}px *2 + 20px)` }}>
            {activeMedicalHealthInformation.document_reference_list.map((data) => {
              return <Card key={data.id} onClick={() => handleCardClick(data)} label={data.name} />;
            })}
            {!!detailDocumentReference.id && (
              <DialogViewer
                type={'pdf'}
                url={detailDocumentReference.url}
                isOpenModal={isOpenModal}
                onClose={() => setIsOpenModal(false)}
                onClickButton={handleUnmask}
                isAlreadyUnmasked={detailDocumentReference.is_masked}
              />
            )}
          </Grid>
        </Grid>
        <Grid item xs={0} md={3} sm={2} />
      </Grid>
      <ErrorDialog
        open={!!errorDialogMessage.length}
        title={'資料を鮮明にできませんでした'}
        buttonLabel="閉じる"
        buttonAction={() => {
          setErrorDialogMessage('');
        }}
      >
        {errorDialogMessage}
      </ErrorDialog>
    </Box>
  );
};
export default MedicalHealthInformationBranchDocumentReference;
